import React from "react"
import { useGetMedicalInfo, useMedicalInfo } from "../../context/MedicalInfoContext"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"
import { Form } from "@carrotfertility/carotene-core-x"
import {
  ButtonFooterLayout,
  ContinueButton,
  RoutingFlowTitle,
  SkipButton,
  StepLayout,
  useConvertTranslatedLabel
} from "#/components/carrot-plans/shared"
import { FormRadioButtonGroup } from "#/services/common-forms"

export default function PastFertilityTreatmentStep(): JSX.Element {
  const intl = useIntl()
  const { updateMedicalInfo, hasQuestionBeenSkipped } = useMedicalInfo()
  const { data: medicalInfo } = useGetMedicalInfo(false)
  const defaultValue = medicalInfo?.pregnancyPastFertilityTreatment

  const { send } = useStateMachine(
    defaultValue || hasQuestionBeenSkipped("pregnancyPastFertilityTreatment") ? "" : null
  )
  const buttonOptions = [
    { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
    { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
  ]
  const radioOptions = useConvertTranslatedLabel(buttonOptions)

  async function onClickContinue(formValues: { pregnancyPastFertilityTreatment: string }): Promise<void> {
    if (formValues?.pregnancyPastFertilityTreatment !== null) {
      await updateMedicalInfo({ pregnancyPastFertilityTreatment: formValues.pregnancyPastFertilityTreatment })
      send("")
    } else {
      await onSkip()
    }
  }

  async function onSkip(): Promise<void> {
    await updateMedicalInfo({ skipFields: ["pregnancyPastFertilityTreatment"] })
    send("")
  }

  const header = intl.formatMessage({
    defaultMessage: "Have you received any type of fertility treatment in the past?"
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={<span id="pregnancyPastFertilityTreatment-label">{header}</span>}
        formElements={
          <Form onSubmit={onClickContinue} defaultValues={{ pregnancyPastFertilityTreatment: defaultValue }}>
            <FormRadioButtonGroup
              name="pregnancyPastFertilityTreatment"
              options={radioOptions}
              aria-labelledby="pregnancyPastFertilityTreatment-label"
            />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
              skipButton={<SkipButton onClick={onSkip} />}
            />
          </Form>
        }
      />
    </>
  )
}
